import { createSelector } from '@ngrx/store';

import { JobBoard } from '@shared/models/job-board';

import { CollectionsState, getCollectionsState } from '../collections.reducer';

export const getJobBoardsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.jobBoards,
);

export const getAllJobBoards = createSelector(getJobBoardsState, (state) => !!state && state.list);

export const getIsJobBoardLoading = createSelector(getJobBoardsState, (state) => state?.isLoading);

export const jobBoardsGetActiveJobBoardsForJob = createSelector(
  getJobBoardsState,
  (state) => state?.activeJobBoardsForJob,
);

export const isAnyJobBoardEnabled = createSelector(getAllJobBoards, (state) =>
  state?.content?.some((jb) => jb.status),
);

export const getAllJobBoardsWithoutPagination = createSelector(
  getJobBoardsState,
  (state) => state?.allJobBoardsList,
);
export const getMappedJobBoardsForJob = createSelector(
  getAllJobBoardsWithoutPagination,
  jobBoardsGetActiveJobBoardsForJob,
  (jobBoards, activeJobBoards) =>
    jobBoards?.map((jobBoard) => {
      const temp = activeJobBoards?.find(
        (activeJobBoard) => activeJobBoard.jobBoardId === jobBoard.id,
      );
      if (temp) {
        jobBoard.isPublished = temp.isPublished;
        jobBoard.jobBoardPostId = temp.id;
      }
      return jobBoard;
    }),
);

export const getMappedStandardJobBoardsForJob = createSelector(
  getMappedJobBoardsForJob,
  (mappedJobBoardsForJob = []) => mappedJobBoardsForJob.filter((jobboard) => jobboard.standard),
);

export const getMappedNonStandardJobBoardsForJob = createSelector(
  getMappedJobBoardsForJob,
  (mappedJobBoardsForJob = []) => mappedJobBoardsForJob.filter((jobboard) => !jobboard.standard),
);

export const getIsJobPublished = createSelector(
  getMappedJobBoardsForJob,
  (mappedJobBoardsForJob) =>
    !!mappedJobBoardsForJob?.some(
      (mappedJobBoard) => mappedJobBoard.isPublished && mappedJobBoard.status,
    ),
);

export const getJobBoardById = createSelector(
  getAllJobBoardsWithoutPagination,
  (boards: JobBoard[], props) => !!boards && boards.find((board) => board.id === props.id),
);

export const getSelectedJobBoard = createSelector(
  getJobBoardsState,
  (state) => state?.selectedJobBoard,
);

export const jobBoardsGetJobBoard = createSelector(getAllJobBoards, (pagination, props) =>
  pagination?.content ? pagination.content.find((jb) => jb.id === props.id) : null,
);

export const isLoadingLogoAttachmentJobBoard = createSelector(
  getJobBoardsState,
  (state) => state?.logoAttachmentLoading,
);

export const getLogoAttachmentJobBoard = createSelector(
  getJobBoardsState,
  (state) => state?.logoAttachment,
);

export const getIdLogoAttachmentJobBoard = createSelector(
  getLogoAttachmentJobBoard,
  (attachment) => attachment?.id,
);

export const isLoadingHeaderAttachmentJobBoard = createSelector(
  getJobBoardsState,
  (state) => state?.headerAttachmentLoading,
);

export const getHeaderAttachmentJobBoard = createSelector(
  getJobBoardsState,
  (state) => state?.headerAttachment,
);

export const getIdHeaderAttachmentJobBoard = createSelector(
  getHeaderAttachmentJobBoard,
  (attachment) => attachment?.id,
);

export const getTotalElementsForExtendedReferral = createSelector(
  getJobBoardsState,
  (state) => state.totalElementsForExtendedReferral,
);
